import { normalizeCurrencyCode } from './formatPaymentAmount';

export const APPOINTMENT_SUCCESS_CONTEXT_KEY = 'appointment_success_context';
export const PAYMENT_CONTEXT_KEY = 'payment_context';

export type AppointmentSuccessContext = {
  title?: string;
  description?: string;
  date?: string;
  time_from?: string;
  time_to?: string;
  timeZoneName?: string;
  servedAt?: string;
  served_at_value?: number;
  served_at_data?: string;
  price?: string | number;
  host?: string;
  visible_to?: number;
  duration?: string | number;
  hide_duration?: boolean;
  rescheduled?: boolean;
  appointment?: unknown;
  ics?: string;
  appointment_nr?: string;
  appointmentId?: string;
  email?: string;
  oldAppointment?: Record<string, unknown> | null;
  access_token?: string;
  payment_hold_expires_at?: string;
  currency?: string;
  currency_label?: string;
};

export type PaymentContext = {
  payment_id: number;
  access_token?: string | null;
  appointment_nr?: string | null;
};

function normalizeStoredContext(
  context: Record<string, unknown>
): AppointmentSuccessContext {
  const normalized: AppointmentSuccessContext = { ...context };

  const currency = normalizeCurrencyCode(context.currency);

  if (currency) {
    normalized.currency = currency;
  } else {
    delete normalized.currency;
  }

  const currencyLabel =
    typeof context.currency_label === 'string'
      ? context.currency_label.trim()
      : '';

  if (currencyLabel) {
    normalized.currency_label = currencyLabel;
  } else {
    delete normalized.currency_label;
  }

  return normalized;
}

export function storeAppointmentSuccessContext(
  context: AppointmentSuccessContext
): void {
  sessionStorage.setItem(
    APPOINTMENT_SUCCESS_CONTEXT_KEY,
    JSON.stringify(context)
  );
}

export function readAppointmentSuccessContext(): AppointmentSuccessContext | null {
  try {
    const raw = sessionStorage.getItem(APPOINTMENT_SUCCESS_CONTEXT_KEY);

    if (!raw) {
      return null;
    }

    return normalizeStoredContext(JSON.parse(raw) as Record<string, unknown>);
  } catch {
    return null;
  }
}

export function storePaymentContext(context: PaymentContext): void {
  sessionStorage.setItem(PAYMENT_CONTEXT_KEY, JSON.stringify(context));
}

export function readPaymentContext(): PaymentContext | null {
  try {
    const raw = sessionStorage.getItem(PAYMENT_CONTEXT_KEY);

    return raw ? (JSON.parse(raw) as PaymentContext) : null;
  } catch {
    return null;
  }
}

export function clearPaymentSession(): void {
  sessionStorage.removeItem(PAYMENT_CONTEXT_KEY);
}

export function clearAppointmentSuccessSession(): void {
  sessionStorage.removeItem(APPOINTMENT_SUCCESS_CONTEXT_KEY);
  clearPaymentSession();
}
